import { stringify } from 'querystring';

import axios from 'utils/axios';
import { populate } from 'utils/strings';

import { processResponse } from './functions/response';

let resource;

/**
 * Send request by GET method
 *
 * @param {object} filters
 * @param {boolean} sort
 * @returns
 */
async function get(filters = {}, sort = false, ignoreId = false) {
  const qs = stringify(filters);

  const response = await axios.get(qs ? `${resource}?${qs}` : resource);

  return processResponse(response, filters, sort, ignoreId);
}

async function get2(filters = {}, sort = false, ignoreId = false) {

  const limit = filters?.limit ?? 25;
  const page = filters?.page ?? 1;
  let managers = filters?.managers ?? '';
  const filter = filters?.filter ?? '';
  //console.log('managers', managers);

  if(managers !== '') {
    
    if (managers.length === 1) {
      managers = `"${parseInt(managers[0])}"`; // Si solo hay un elemento, lo conviertes a entero y luego a string
    } else {
      managers = managers
        .map((manager) => `"${parseInt(manager)}"`) // Convertir cada elemento a entero
        .join(','); // Formatear como '23','43','54'
    }

    resource = resource.replace('"managers": []', `"managers": [${managers}]`);
  }
  
  const url = `${resource.replace('"filter":""', `"filter":"${filter}"`)}&limit=${limit}&page=${page}`;
  //console.log(url);
  const response = await axios.get(url);
  
  return processResponse(response, filters, sort, ignoreId);
}

/**
 * Send request by POST method
 *
 * @param {object} payload
 * @returns
 */
async function post(payload, responseAsGet = false) {
  const response = await axios.post(resource, payload);
  const { data: { data = [], total = 0 } } = response;

  if (responseAsGet) {
    return {
      values: data,
      total,
    };
  } else {
    const [values] = Array.isArray(data) ? data : [data];

    return values;
  }
}

/**
 * Send request by PUT method
 *
 * @param {object} payload
 * @returns
 */
async function put(payload, filters = undefined) {
  const shouldAppendQs =
    filters &&
    typeof filters === 'object' &&
    !Array.isArray(filters) &&
    Object.keys(filters).length > 0;

  const url = shouldAppendQs ? `${resource}?${stringify(filters)}` : resource;
  const response = await axios.put(url, payload);
  const { data: { data = [] } } = response;
  const [values] = Array.isArray(data) ? data : [data];

  return values;
}

/**
 * Send request by DELETE method
 *
 * @param {object} filters
 * @param {boolean} inBody
 * @returns
 */
async function del(filters = {}, inBody = false) {
  const qs = stringify(filters);
  const response = inBody
    ? await axios.delete(resource, {
      data: filters,
    })
    : await axios.delete(qs ? `${resource}?${qs}` : resource);
  const { data: { data } } = response;
  const [values] = Array.isArray(data) ? data : [data];

  return values;
}

/**
 * @deprecated
 */
const create = post;

/**
 * @deprecated
 */
const update = put;

/**
 *
 * @param {string} service
 * @param {object} params
 * @returns
 */
export const Dynamicore = (service, params = {}) => {
  resource = populate(service, params);

  return {
    get,
    get2,
    post,
    put,
    delete: del,

    create,
    update,
  };
};
